<template>
    <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="' الحفظ والمراجعة'" :to="{name: 'saveReviews'}"> الحفظ والمراجعة</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">


                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i>
                                        متابعة الحفظ والمراجعة
                                        </h4>
                                    </div>
                                    <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item">

                                          <create-button  v-if="hasPermissions('saveReviews_create')" :routeName="'saveReviews.create'"></create-button>
                                        </li>
                                        <li class="list-inline-item">

                                          <button class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1" v-if="searchingMode == 0" @click="searchingMode = 1"><span>فلاتر البحث</span></button>
                                <button class="btn btn-danger search-btn-wg mb-2 my-2" v-if="searchingMode == 1" @click="searchingMode = 0">إغلاق X</button>

                                          </li>

                                      </ul>

                                      </div>
                                </div>


                            </div>
                            <div class="widget-content widget-content-area">

                                <form @submit.prevent="getIndexData(1)" v-if="searchingMode == 1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                        <div class="col-md-6 mt-2">
                                          <label for="">من تاريخ </label>
                                          <date-picker v-model="data.searching.date_from" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">إلى تاريخ </label>
                                          <date-picker v-model="data.searching.date_to" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for=""> الحالة</label>
                                          <select name="is_draft" v-model="data.searching.is_draft" class="form-control">
                                            <option value="">الكل</option>
                                            <option value="1">مؤقت</option>
                                            <option value="0">محفظ</option>
                                          </select>
                                        </div>
                                        <div class="col-md-12 mt-5">
                                                                      <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>
                                          <!-- <input type="submit" name="time" class=" btn btn-button-7 btn-block" value="بــــحــث"> -->
                                        </div>
                                    </div>
                                </form>

                                <div class="table-responsive">
                                    <div class="row mb-2">
                                      <div class="col-md-1">
                                        <span>إظهار</span>
                                        <select v-model="data.searching.perPage" @change="getIndexData(1)" class="form-control">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                      </div>
                                    </div>
                                    <div class="col-md-12">
                                      <button @click.prevent="printTable" v-if="data.data.length" class="btn btn-success mt-2 mb-2">
                                        <i class="fa fa-print"></i> طباعة
                                      </button>
                                    </div>
                                    <div class="col-md-12" id="print-table">
                                          
                                        <table class="table table-bordered mb-4">
                                            <thead>
                                                <tr>
                                                    <th>
                                                      <a href="#" @click.prevent="resortData();">
                                                        <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                        <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                      </a>
                                                    </th>
                                                    <th @click="resortData();">الحلقة</th>
                                                    <th @click="resortData();" v-if="user.role == 'admin'">المعلم</th>
                                                    <th @click="resortData();">التاريخ</th>
                                                    <th @click="resortData();">مؤقت</th>
                                                    <th class="align-center">#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in data.data" :key="index">
                                                    <td>{{index+1}}</td>
                                                    <td>{{item.lesson.name}}</td>
                                                    <td  v-if="user.role == 'admin'">{{item.teacher.name}}</td>
                                                    <td>{{item.date_and_time}}</td>
                                                    <td>{{item.is_draft == 1 ? 'نعم' : 'لا'}}</td>
                                                    <td class="text-center">

                                                        <div class="dropdown custom-dropdown">
                                                            <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                <i class="flaticon-dot-three fs-17"></i>
                                                            </a>

                                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                                <a href="#" v-if="item.is_draft == 0" class="dropdown-item" @click.prevent="print(item)">طباعة</a>
                                                                <edit-button v-if="hasPermissions('saveReviews_edit')" :routing="{name: 'saveReviews.edit', params: {id: item.id}}" :title="'تعديل'"></edit-button>
                                                                <delete-button v-if="hasPermissions('saveReviews_delete')" :deleteUrl="'/saveReviews/' + item.id" :data="item" @deleteData="deleteData"></delete-button>
                                                            </div>
                                                        </div>

                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>
                                                      <a href="#" @click.prevent="resortData();">
                                                        <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                        <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                      </a>
                                                    </th>
                                                    <th @click="resortData();">الحلقة</th>
                                                    <th @click="resortData();"  v-if="user.role == 'admin'">المعلم</th>
                                                    <th @click="resortData();">التاريخ</th>
                                                    <th @click="resortData();">مؤقت</th>

                                                    <th class="align-center">#</th>
                                                </tr>
                                            </tfoot>

                                        </table>
                                    </div>

                                </div>
                                 <div class="row">
                                  <div class="col-md-4">
                                    <simple-pagination :data="data.paginated" @getIndexData="getIndexData($event)"></simple-pagination>
                                  </div>
                                  <div class="col-md-8 mt-4">
                                    <table-info v-if="Object.keys(data.paginated).length" :data="data.paginated"></table-info>
                                  </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                  <div class="row" style="display: none;" id="printMe">
                <div class="col-md-12">
                    <table>
                        <tbody class="text-center">
                            <tr>
                                <td>{{printData.date_and_time}}</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr class="text-center">
                                <td></td>
                                <td>{{printData.lesson.name}}</td>
                                <td></td>
                            </tr>
                            <tr class="text-center">
                                <td></td>
                                <td>المعلم /{{printData.teacher.name}}</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                   <table class="table table-bordered">
                    <tbody>
                    </tbody>
                    <tbody>
                        <tr class="text-center">
                            <th colspan="2">الطالب</th>
                            <th colspan="5">متابعة الحفظ</th>
                            <th colspan="5">متابعة المراجعة</th>
                            <th>درجة النهائية</th>
                        </tr>

                        <tr >
                            <th>اسم الطالب</th>
                            <th>نوع الورد</th>
                            <th>من سورة</th>
                            <th>رقم الآية</th>
                            <th>إلى سورة</th>
                            <th>رقم الآية</th>
                            <th>درجة الحفظ</th>

                            <th>من سورة</th>
                            <th>رقم الآية</th>
                            <th>إلى سورة</th>
                            <th>رقم الآية</th>
                            <th>درجة المراجعة</th>

                            <th>الدرجة النهائية</th>
                        </tr>

                        <tr  v-for="(st, k) in printData.save_review_students" :key="k">
                            <th>{{st.student_name}}</th>
                            <th>{{ st.type }}</th>
                            <th>{{ st.save_from }}</th>
                            <th>{{ st.save_from_aya }}</th>
                            <th>{{ st.save_to }}</th>
                            <th>{{ st.save_to_aya }}</th>
                            <th>{{ st.save_degree }}</th>

                            <th>{{ st.review_from }} </th>
                            <th>{{ st.review_from_aya }}</th>
                            <th>{{ st.review_to}}</th>
                            <th>{{ st.review_to_aya }}</th>
                            <th> {{ st.review_degree }}</th>

                            <th>{{ st.student_degree }}</th>
                        </tr>



                    </tbody>
                  </table>
                </div>
              </div>

            </div>


</template>
<script>
import VueDatetimeJs from 'vue-datetime-js'
export default {
    components: {
    datePicker: VueDatetimeJs,
  },
  data() {
    return {
      data: {
        data: {},
        searching:{
            date_from: '',
            date_to: '',
            perPage: 10,
            sorting: 'desc',
            is_draft: ''
        },
        paginated: {},
        showFilter: false,
      },
      searchingMode: 0,
      printData: {save_review_students: [], lesson: {}, teacher: {}}
    };
  },
  created(){
    this.flashAlert();
      this.getIndexData(1);
  },
  methods: {
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
    printTable(){
      setTimeout(() => {
        this.print_element('print-table', 'الحفظ والمراجعة');
      }, 1000);
    },
    print(data){
      this.printData = data;
      setTimeout(() => {
      this.$htmlToPaper('printMe');

      }, 3000);
    },
      getIndexData(page){
          this.$baseApi.get('/saveReviews?page=' + page, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
               this.data.paginated = response.data.data.saveReviews;
               this.data.data = response.data.data.saveReviews.data;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    }
  },
  computed: {
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  }
};
</script>
<style>
</style>
